import { t } from "../../../services/utils";
import React from "react";
class Space extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        paddingBottom: this.props.paddingBottom ? this.props.paddingBottom : 0,
      },
      el: {
        height: 1,
      },
    };
    return (
      <div style={styles.container}>
        <div style={styles.el} />
      </div>
    );
  };
  static getHeight(props) {
    let height = 1;
    if (props.paddingBottom) {
      height += props.paddingBottom;
    }
    return height;
  }
}
export default Space;
